import React, { useCallback, useMemo } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { blue, red } from "../../../utils/colors";
import { Breakpoint } from "../../Theme";

const DoubleShape = ({
    children,
    shapeRight = false,
    width = 1,
    rightBlue = false,
    rightContainerStyles = undefined,
}) => {
    const skewHelper = (after = false) => {
        if (after) {
            return shapeRight ? "skew(32deg)" : "skew(-32deg)";
        }
        return shapeRight ? "skew(-32deg)" : "skew(32deg)";
    };

    const BackgroundColorBlue = css`
        background-color: ${blue};
    `;

    const theme = useTheme();

    const widthHelper = useCallback(
        (right = false) => {
            if (width === 2) {
                if (!right) {
                    return theme.breakpoints.propPerEachUpTo("width", {
                        [Breakpoint.extraLarge]: "80%",
                    });
                }
                return theme.breakpoints.propPerEachUpTo("width", {
                    [Breakpoint.extraLarge]: "17%",
                });
            }
            if (!right) {
                return theme.breakpoints.propPerEachUpTo("width", {
                    [Breakpoint.extraLarge]: "50%",
                    [Breakpoint.small]: "70%",
                    [Breakpoint.extraSmall]: "90%",
                });
            }
            return theme.breakpoints.propPerEachUpTo("width", {
                [Breakpoint.extraLarge]: "47%",
                [Breakpoint.small]: "27%",
                [Breakpoint.extraSmall]: "75%",
            });
        },
        [theme, width]
    );
    const widthLeft = useMemo(() => widthHelper(), [widthHelper]);
    const widthRight = useMemo(() => widthHelper(true), [widthHelper]);

    const Container = styled.div`
        position: relative;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
    `;

    const LeftContainer = styled.div`
        position: relative;
        ${widthLeft};
    `;

    const LeftContentContainer = styled.div`
        position: relative;
        z-index: 1;
    `;

    const LeftShapeContainer = styled.div`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: -150px;
        background-color: ${red};
        border-radius: 40px;
        transform: ${skewHelper()};
    `;

    const RightContainer = styled.div`
        position: relative;
        ${widthRight};
    `;

    const RightShapeContainer = styled.div`
        position: absolute;
        top: 0;
        right: -150px;
        bottom: 0;
        left: 0;
        overflow: hidden;
        border-radius: 40px;
        transform: ${skewHelper()};
    `;

    const RightContentContainer = styled.div`
        position: relative;
        z-index: 1;
        width: auto;
        height: 100%;
        transform: ${skewHelper(true)};
    `;

    return (
        <Container>
            <LeftContainer>
                <LeftContentContainer>{children[0]}</LeftContentContainer>
                <LeftShapeContainer />
            </LeftContainer>
            <RightContainer>
                <RightShapeContainer
                    css={css`
                        ${rightBlue && BackgroundColorBlue}
                        ${rightContainerStyles && rightContainerStyles}
                    `}
                >
                    <RightContentContainer>{children[1]}</RightContentContainer>
                </RightShapeContainer>
            </RightContainer>
        </Container>
    );
};

export default DoubleShape;
